<template>
  <DropdownComponent class="tour-trigger" placement="bottom-start">
    <template #default>
      <ButtonComponent
        :label="$t('needHelp')"
        :icon="{ icon: ['fas', 'question-circle'] }"
        class="tour-trigger__button"
      />
    </template>
    <template #dropdown>
      <!-- <template v-if="onscreens.length">
        <strong class="tour-trigger__title">
          {{ $t('tourTitleOnScreen') }}
          <FontAwesomeIcon size="lg" :icon="['fal', 'info-circle']" class="ml-1" />
        </strong>
        <ButtonComponent
          v-for="item in onscreens"
          :key="item.id"
          :label="item.label"
          :icon="item.icon"
          @click="action(item.id)"
        />
      </template>-->
      <template v-if="manuals.length">
        <strong class="tour-trigger__title">
          {{ $t('tourTitleManuals') }}
          <FontAwesomeIcon size="lg" :icon="['fal', 'info-circle']" class="ml-1" />
        </strong>
        <ButtonComponent
          v-for="(item, index) in manuals"
          :key="item.id + '--' + index"
          :label="item.label"
          :icon="item.icon"
          tag="a"
          target="_blank"
          :href="`https://help.kvass.no/nb/articles/${item.id}`"
        />
      </template>
      <template v-if="videos.length">
        <strong class="tour-trigger__title">
          {{ $t('tourTitleCourseVideos') }}
          <FontAwesomeIcon size="lg" :icon="['fal', 'play-circle']" class="ml-1" />
        </strong>
        <ButtonComponent
          v-for="(item, index) in videos"
          :key="item.id + '--' + index"
          :label="item.label"
          :icon="item.icon"
          tag="a"
          target="_blank"
          :href="`https://help.kvass.no/nb/articles/${item.id}`"
        />
      </template>
      <template v-if="additionalServices.length">
        <strong class="tour-trigger__title tour-trigger__title--additional-services">
          {{ $t('tourTitleAdditionalServices') }}
          <FontAwesomeIcon size="lg" :icon="['fal', 'user-headset']" class="ml-1" />
        </strong>
        <Upsell v-for="item in additionalServices" :key="item.id" :value="item.id" />
      </template>
    </template>
  </DropdownComponent>
</template>

<script>
import { DropdownComponent } from 'vue-elder-dropdown'
import Upsell from '@/components/Upsell/Trigger'
import GetItems from './items'

let TypeFilter = type => item => item.type === type

export default {
  props: {
    value: {
      type: Object,
    },
  },
  computed: {
    allItems() {
      let { categories, ...options } = this.value
      return GetItems(categories, options)
    },
    manuals() {
      return this.allItems.filter(TypeFilter('manual'))
    },
    // onscreens() {
    //   return this.allItems.filter(TypeFilter('onscreen'))
    // },
    videos() {
      return this.allItems.filter(TypeFilter('video'))
    },
    additionalServices() {
      return this.allItems.filter(TypeFilter('additional-services'))
    },
    items() {
      return this.tour.filter(item => {
        if (!('condition' in item)) return true
        return item.condition
      })
    },
  },
  methods: {
    getBinding(item) {
      let binding = {
        label: item.label,
        icon: item.icon,
      }
      let listeners = {}

      switch (item.type) {
        case 'manual':
        case 'video':
          binding.tag = 'a'
          binding.target = '_blank'
          binding.href = item.action
        case 'onscreen':
        case undefined:
          listeners.click = () => this.action(item.id)
          break
      }

      return {
        binding,
        listeners,
      }
    },
    action(id) {
      window.Intercom('startTour', id)
    },
  },
  components: {
    DropdownComponent,
    Upsell,
  },
}
</script>

<style lang="scss">
.tour-trigger {
  &__button {
    --vue-elder-button-padding-x: 1rem;
    --vue-elder-button-padding-y: 0.5rem;
    font-size: 0.8rem !important;
    border-radius: 50px !important;
    border: none;
  }

  &__title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &--additional-services {
      background-color: css-alpha('primary', 0.2) !important;

      & + * {
        background-color: css-alpha('primary', 0.1) !important;
      }
    }
  }

  .elder-dropdown__content {
    font-size: 0.8rem;
    min-width: 300px;
    color: var(--dark);
    max-height: 800px;
    overflow-y: auto;
  }
}
</style>
